// extracted by mini-css-extract-plugin
export default {"customIcon":"SocialIcon_customIcon__5MV7D"};